import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './lang/en/en.json';
import sv from './lang/sv/sv.json';
import no from './lang/no/no.json';
import da from './lang/da/da.json';
import de from './lang/de/de.json';
import fi from './lang/fi/fi.json';
import is from './lang/is/is.json';
import fr from './lang/fr/fr.json';
import cz from './lang/cz/cz.json';

const resources = {
  en: {
    translation: en,
  },
  sv: {
    translation: sv,
  },
  no: {
    translation: no,
  },
  da: {
    translation: da,
  },
  de: {
    translation: de,
  },
  fi: {
    translation: fi,
  },
  is: {
    translation: is,
  },
  fr: {
    translation: fr,
  },
  cz: {
    translation: cz,
  },
};

i18n.use(detector).use(initReactI18next).init({
  resources,
  fallbackLng: 'sv',
  saveMissing: true,
});

export default i18n;
